export const endPoints = {
  EXPO_CONTACT_TOKEN: (token: string) => {
    return `/v1/expo/contact?token=${token}`;
  },
  EXPO_CONTACT: '/v1/expo/contact'
};
